import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkTranscriptionReconnectedAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_TRANSCRIPTION_RECONNECTED_AUDIO_RECORDING";
  }

  // Transcription reconnect doesn't change model status fields
  // The event is tracked for observability purposes
}
